import React from 'react'
import PropTypes from 'prop-types'

const InputRowReadOnly = (props) => {
    return (
        <div>
            <div className='form-control my-4 my-md-3'>
                {props.label
                    ? <label>
                        {props.label}
                        <br />
                        {props.children}
                      </label>
                    : ''}
                <div>
                    <input
                        value={props.value ? props.value : ''}
                        onChange={() => {}}
                        className='bg-lightgrey'
                        disabled
                    />
                </div>
            </div>
        </div>
    )
}

InputRowReadOnly.propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default InputRowReadOnly



// WEBPACK FOOTER //
// ./resources/js/elements/InputRowReadOnly.js